import { render, staticRenderFns } from "./targets-employees-table.vue?vue&type=template&id=512c4be3&scoped=true"
import script from "./targets-employees-table.vue?vue&type=script&lang=js"
export * from "./targets-employees-table.vue?vue&type=script&lang=js"
import style0 from "./targets-employees-table.vue?vue&type=style&index=0&id=512c4be3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c4be3",
  null
  
)

export default component.exports